import Icon from './Icon';

const Coin = (props) => (
  <Icon pathFillRule="evenodd" pathClipRule="evenodd" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32ZM15.9985 26.6736C21.8958 26.6736 26.6766 21.8928 26.6766 15.9954C26.6766 10.0981 21.8958 5.3173 15.9985 5.3173C10.1011 5.3173 5.32031 10.0981 5.32031 15.9954C5.32031 21.8928 10.1011 26.6736 15.9985 26.6736Z"
      fill="url(#paint0_linear)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.9998 26.5295C22.1619 26.5295 26.5863 21.5491 26.5863 15.2548H28.3068C28.3068 22.3644 23.2416 28.25 15.9998 28.25C11.6414 28.25 8.15915 26.1064 5.81641 22.8751L7.20931 21.8652C9.27679 24.7169 12.2703 26.5295 15.9998 26.5295Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.008 5.44887C9.84588 5.44887 5.42149 10.4293 5.42149 16.7236H3.70101C3.70101 9.61396 8.76623 3.7284 16.008 3.7284C20.3664 3.7284 23.8487 5.87199 26.1914 9.10326L24.7985 10.1131C22.731 7.26154 19.7376 5.44887 16.008 5.44887Z"
      fill="#D37A32"
    />
    <mask id="path-4-inside-1" fill="white">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.5835 16.1899C26.7131 13.6693 25.9229 11.8411 24.7151 10.0173L26.1495 9.06732C27.4825 11.0801 28.4564 13.2704 28.3017 16.2783L26.5835 16.1899ZM5.4197 16.6849C5.4197 19.1139 6.16679 20.8295 7.6718 22.5411L6.37977 23.6772C4.62606 21.6828 3.69922 19.5718 3.69922 16.6849H5.4197Z"
      />
    </mask>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26.5835 16.1899C26.7131 13.6693 25.9229 11.8411 24.7151 10.0173L26.1495 9.06732C27.4825 11.0801 28.4564 13.2704 28.3017 16.2783L26.5835 16.1899ZM5.4197 16.6849C5.4197 19.1139 6.16679 20.8295 7.6718 22.5411L6.37977 23.6772C4.62606 21.6828 3.69922 19.5718 3.69922 16.6849H5.4197Z"
      fill="var(--color-i-orange-1)"
    />
    <path
      d="M24.7151 10.0173L17.6658 -0.627027L7.02144 6.42231L14.0708 17.0666L24.7151 10.0173ZM26.5835 16.1899L13.8334 15.534L13.1775 28.2841L25.9276 28.9399L26.5835 16.1899ZM26.1495 9.06732L36.7938 2.01799L29.7445 -8.62633L19.1002 -1.577L26.1495 9.06732ZM28.3017 16.2783L27.6458 29.0283L40.3959 29.6842L41.0517 16.9341L28.3017 16.2783ZM7.6718 22.5411L16.1023 32.1287L25.6898 23.6982L17.2594 14.1107L7.6718 22.5411ZM5.4197 16.6849H18.1866V3.91797H5.4197V16.6849ZM6.37977 23.6772L-3.20781 32.1077L5.22265 41.6953L14.8102 33.2648L6.37977 23.6772ZM3.69922 16.6849V3.91797H-9.06771V16.6849H3.69922ZM14.0708 17.0666C14.3107 17.4289 14.1799 17.3033 14.0353 16.8681C13.9607 16.6437 13.8993 16.3894 13.8636 16.1239C13.8281 15.8606 13.8271 15.6559 13.8334 15.534L39.3335 16.8457C39.6491 10.7104 37.497 6.19569 35.3594 2.96796L14.0708 17.0666ZM19.1002 -1.577L17.6658 -0.627027L31.7644 20.6616L33.1989 19.7116L19.1002 -1.577ZM41.0517 16.9341C41.3926 10.3084 39.0542 5.43107 36.7938 2.01799L15.5052 16.1167C15.7931 16.5514 15.7489 16.5692 15.6687 16.3279C15.6271 16.2027 15.5906 16.0536 15.5693 15.8982C15.5481 15.7437 15.5505 15.6444 15.5516 15.6224L41.0517 16.9341ZM25.9276 28.9399L27.6458 29.0283L28.9575 3.52818L27.2393 3.43979L25.9276 28.9399ZM17.2594 14.1107C17.2252 14.0717 17.5611 14.4483 17.8511 15.1805C18.1525 15.9416 18.1866 16.5333 18.1866 16.6849H-7.34724C-7.34724 22.5107 -5.26732 27.16 -1.91579 30.9716L17.2594 14.1107ZM14.8102 33.2648L16.1023 32.1287L-0.758667 12.9535L-2.05069 14.0896L14.8102 33.2648ZM-9.06771 16.6849C-9.06771 22.9714 -6.80612 28.0155 -3.20781 32.1077L15.9674 15.2467C15.8438 15.1063 16.0527 15.3122 16.2508 15.8124C16.3437 16.0468 16.4033 16.2689 16.4365 16.4535C16.4687 16.6322 16.4662 16.7201 16.4662 16.6849H-9.06771ZM5.4197 3.91797H3.69922V29.4518H5.4197V3.91797Z"
      fill="url(#paint1_linear)"
      mask="url(#path-4-inside-1)"
    />
    <circle cx="15.9985" cy="15.9955" r="10.6781" fill="url(#paint2_linear)" />
    <path
      d="M10.0544 11.6875C10.0544 14.9722 12.7187 17.6274 15.9943 17.6274C19.27 17.6274 21.9434 14.9722 21.9434 11.6875H10.0544Z"
      fill="url(#paint3_linear)"
    />
    <path
      d="M13.0047 21.7741C13.0047 20.1226 14.346 18.7813 15.9975 18.7813C17.649 18.7813 18.9902 20.1226 18.9902 21.7741H13.0047Z"
      fill="url(#paint4_linear)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.5234 17.6078C15.6832 17.6208 15.8447 17.6273 16.0078 17.6273C19.2834 17.6273 21.9568 14.9722 21.9568 11.6874H20.988C20.988 14.8087 18.5742 17.3614 15.5234 17.6078Z"
      fill="#D37A32"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.0318 21.774H19.0006C19.0006 20.1225 17.6593 18.7812 16.0078 18.7812C15.8429 18.7812 15.6811 18.7946 15.5234 18.8203C16.945 19.0522 18.0318 20.2874 18.0318 21.774Z"
      fill="#D37A32"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="16"
        y1="0"
        x2="16"
        y2="32"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFD450" />
        <stop offset="1" stopColor="#F2C230" />
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x1="16.0085"
        y1="9.06732"
        x2="16.0085"
        y2="23.6772"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F2B37B" />
        <stop offset="1" stopColor="#EE8F3A" />
      </linearGradient>
      <linearGradient
        id="paint2_linear"
        x1="15.9985"
        y1="5.31732"
        x2="15.9985"
        y2="26.6736"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFD450" />
        <stop offset="1" stopColor="#F2C230" />
      </linearGradient>
      <linearGradient
        id="paint3_linear"
        x1="15.9989"
        y1="11.6875"
        x2="15.9989"
        y2="17.6274"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F2B37B" />
        <stop offset="1" stopColor="#EE8F3A" />
      </linearGradient>
      <linearGradient
        id="paint4_linear"
        x1="15.9975"
        y1="18.7813"
        x2="15.9975"
        y2="21.7741"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F2B37B" />
        <stop offset="1" stopColor="#EE8F3A" />
      </linearGradient>
    </defs>
  </Icon>
);

export default Coin;
